export const POPULAR_KEYWORDS = [
    { term: 'LEGO Sets', slug: 'lego' },
    { term: 'Hot Wheels', slug: 'hot-wheels' },
    { term: 'Barbie Dolls', slug: 'barbie' },
    { term: 'Action Figures', slug: 'action-figures' },
    { term: 'Board Games', slug: 'board-games' },
    { term: 'Educational Toys', slug: 'educational' },
    { term: 'Bicycles for Kids', slug: 'bicycle' },
    { term: 'PlayStation Games', slug: 'playstation' },
    { term: 'Soft Toys', slug: 'soft-toys' },
    { term: 'Die-cast Cars', slug: 'cars' }
];

export const SEO_SEARCH_SUGGESTIONS = [
    'buy toys online Pakistan',
    'toy price in Pakistan',
    'second hand toys Karachi',
    'toy exchange Lahore',
    'baby toys Islamabad',
    'collectible items Pakistan'
];
